<!-- grid -->
<section class="grid">
  <!-- head -->
  <div class="grid-head">
    <div *ngIf="_grid.totalPages > 0 && gridName && gridSubtitle" style="padding-top: 12px;">
      <div *ngIf="gridName && showGridName" class="grid-filter">
        <label class="typo body-2 fw400 semi-condensed label-filter">{{gridName}}</label>
      </div>
      <div *ngIf="gridSubtitle && showGridSubtitle">
        <label class="typo body-1 fw400 semi-condensed label-filter">{{gridSubtitle}}</label>
      </div>
    </div>
    <div class="grid-head-inner">

      <div *ngIf="gridName && showGridName && !gridSubtitle && !showGridSubtitle" class="grid-filter">
        <label class="typo body-2 fw400 semi-condensed label-filter">{{gridName}}</label>
      </div>
      <div *ngIf="gridFilter && _skeleton.skeletonGridLoader" class="grid-filter">
        <panel-filters
          [panelFiltersSectionId]="panelFiltersSectionId"
          [panelFiltersGroupDisplayName]="panelFiltersGroupDisplayName"
          [numberOfItems]="_grid.totalItems"
          (onSetDefaultValues)="setDefaultValues()"
          (onGetGridData)="getGridData(true)">
        </panel-filters>
      </div>

      <div *ngIf="gridFilter && !_skeleton.skeletonGridLoader" class="grid-filter">
        <skeleton-loader [theme]="{'width': '100px'}"></skeleton-loader>
      </div>

      <div *ngIf="gridSearch && _skeleton.skeletonGridLoader" class="grid-search">
        <div class="head-search">
          <panel-grid-search
            [_inputSearchPlaceholder]=gridInputSearchPlaceholder
            [_preSetInputText]="gridPreSetInputText"
            (onSetDefaultValues)="setDefaultValues()"
            (onGetGridData)="getGridData(true)">
          </panel-grid-search>
        </div>
      </div>

      <div *ngIf="gridSearch && !_skeleton.skeletonGridLoader" class="grid-search">
        <div class="head-search">
          <skeleton-loader [theme]="{'width': '300px', 'height': '30px'}"></skeleton-loader>
        </div>
      </div>

      <div *ngIf="gridImport && _skeleton.skeletonGridLoader" class="grid-actions">
        <a mat-icon-button color="primary" [routerLink]="[importPath]" class="custom-mat-icon-button button-head-action">
          <mat-icon svgIcon="ico-import" class="custom-mat-icon ico-size ico-xs"></mat-icon>
        </a>
      </div>

      <div *ngIf="gridImport && !_skeleton.skeletonGridLoader" class="grid-actions">
        <skeleton-loader [theme]="{'width': '20px', 'height': '20px', 'border-radius': '20px', 'margin': '10px'}"></skeleton-loader>
      </div>

      <ng-container *appRestriction="'feature_gridexport|enabled|SCOPE_HIDE'">
        <div class="export-icon" *ngIf="exportCSV && _skeleton.skeletonGridLoader">
          <button mat-icon-button (click)="export()" color="primary" disableRipple="true" class="custom-mat-icon-button ico-export-csv">
            <mat-icon svgIcon="ico-export-csv" class="custom-mat-icon ico-size ico-xs"></mat-icon>
          </button>
        </div>
      </ng-container>
      <div *ngIf="gridPanelPreferences && _skeleton.skeletonGridLoader" class="grid-settings">
        <button mat-icon-button (click)="panelPref.toggleGridPreferences()" color="primary" disableRipple="true" class="custom-mat-icon-button">
          <mat-icon svgIcon="ico-settings" class="custom-mat-icon ico-size ico-xs"></mat-icon>
        </button>
      </div>

      <div *ngIf="gridPanelPreferences && !_skeleton.skeletonGridLoader" class="grid-settings">
        <skeleton-loader [theme]="{'width': '20px', 'height': '20px', 'border-radius': '20px', 'margin': '10px'}"></skeleton-loader>
      </div>
    </div>
  </div>
  <!-- content -->
  <div class="form-content grid-container">
    <div *ngIf="_grid.totalPages > 1" class="grid-paginator">
      <mat-paginator color="primary" showFirstLastButtons="true" class="custom-mat-paginator"
                     [length]="_grid.totalItems" [pageSize]="_grid.itemsPerPage" [pageSizeOptions]="paginatorList" [pageIndex]="_grid.pageIndex"
                     (page)="_grid.onPageChange($event)"></mat-paginator>
    </div>
    <ng-content *ngIf="_grid.statusGridMessage !== 'isVisible'"></ng-content>
    <div *ngIf="_grid.totalPages > 1" class="grid-paginator">
      <mat-paginator color="primary" showFirstLastButtons="true" class="custom-mat-paginator"
        [length]="_grid.totalItems" [pageSize]="_grid.itemsPerPage" [pageSizeOptions]="paginatorList" [pageIndex]="_grid.pageIndex"
        (page)="_grid.onPageChange($event)"></mat-paginator>
    </div>
  </div>
</section>

<!-- grid Search messages -->
<section *ngIf="sectionMessage" [@showWhenLoaded]="_grid.statusGridMessage" class="{{gridSearchClassMessage}}">
  <div *ngIf="_grid.totalPages == 0" class="message-wrapper">
    <div class="message-inner nodata">
      <div class="message-head" *ngIf="!!gridSearchNotFoundImage" >
        <img class="custom-img no-data" src="{{gridSearchNotFoundImage}}">
      </div>
      <div class="message-body">
        <h1 class="message-title" *ngIf="!!gridSearchNotFoundTitle">{{gridSearchNotFoundTitle}}</h1>
        <p class="message-description" *ngIf="!!gridSearchNotFoundDescription">{{gridSearchNotFoundDescription}}</p>
      </div>
    </div>
  </div>
</section>

<!-- grid Empty messages -->
<section *ngIf="sectionMessageEmpty" [@showWhenLoaded]="_grid.statusGridMessage" class="{{gridSearchClassMessage}}">
  <div class="message-wrapper">
    <div class="message-inner nodata">
      <div class="message-body">
        <h1 class="message-title" *ngIf="!!gridDataNotFoundTitle">{{gridDataNotFoundTitle}}</h1>
        <p class="message-description" *ngIf="!!gridDataNotFoundDescription">{{gridDataNotFoundDescription}}</p>
      </div>
    </div>
  </div>
</section>

<!-- grid preferences panel -->
<panel-preferences #panelPref class="panel-gear-settings panel-grid-preference" title="Preferences" [collectionOfGridColumn]="collectionOfGridColumn"></panel-preferences>
